export function fromStringToTicks(strDate: string): number {
  const datum = Date.parse(strDate);
  return datum / 1000;
}

export function fromStringToDate(strDate: string): Date {
  const datum = Date.parse(strDate);
  return fromTicksToDate(datum / 1000);
}

export function fromTicksToDate(timestamp: number): Date {
  return new Date(timestamp * 1000);
}

export const fixTimezoneOffsetToString = (date: Date | number | string): string => {
  if (!date) return '';
  const realDate = new Date(date);
  return new Date(realDate.getTime() - realDate.getTimezoneOffset() * 60000).toJSON();
};

export const fixTimezoneOffsetToDate = (date: Date | number | string): Date | undefined => {
  if (!date) return undefined;
  return new Date(fixTimezoneOffsetToString(date));
};

export function formatDate(date: string): string {
  const dateParts = date.split('-');
  return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
}
